export default {
    search: {
        dataTableId: 'search',
        value: '',
    },
    page: {
        value: 0,
    },
    length: {
        value: 25,
    },
};
